// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowCollegeActionsMenu = ({
  row,
  onEdit,
  onDelete,
  onUploadLogo,
  onCreateCollegeUser,
  onCreateCollegeProgram,
  onCreateAdmissionBatch,
  onViewCollegeUsers,
  onViewCollegePrograms,
  hasPermissionDirect,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_college_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onEdit(row);
            handleClose();
          }}
        >
          Edit College
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onDelete(row.college_id, row.society_id);
            handleClose();
          }}
        >
          Delete College
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onUploadLogo(row.college_id, row.college_name, row.society_id, row.college_logopath);
            handleClose();
          }}
        >
          Upload Logo
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateCollegeUser(row.college_id, row.college_name, row.society_id);
            handleClose();
          }}
        >
          Create User
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewCollegeUsers(row.college_id, row.college_name, row.society_id);
            handleClose();
          }}
        >
          View Users
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateAdmissionBatch(row.college_id, row.college_name, row.society_id);
            handleClose();
          }}
        >
          Create Admission Batch
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateCollegeProgram(row.college_id, row.college_name, row.society_id);
            handleClose();
          }}
        >
          Create Program
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewCollegePrograms(row.college_id, row.college_name, row.society_id);
            handleClose();
          }}
        >
          View Programs
        </MenuItem>
      </Menu>
    </>
  );
};
RowCollegeActionsMenu.propTypes = {
  row: PropTypes.shape({
    college_id: PropTypes.number.isRequired,
    college_name: PropTypes.string.isRequired,
    society_id: PropTypes.number.isRequired,
    college_refurl: PropTypes.string.isRequired,
    college_email: PropTypes.string.isRequired,
    is_college_active: PropTypes.number.isRequired,
    college_logopath: PropTypes.string.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUploadLogo: PropTypes.func.isRequired,
  onCreateCollegeUser: PropTypes.func.isRequired,
  onCreateCollegeProgram: PropTypes.func.isRequired,
  onViewCollegeUsers: PropTypes.func.isRequired,
  onViewCollegePrograms: PropTypes.func.isRequired,
  onCreateAdmissionBatch: PropTypes.func.isRequired,
  hasPermissionDirect: PropTypes.func.isRequired,
};
export default RowCollegeActionsMenu;
